<template>
  <div class="all">
    <h2 class="large-title">User Report</h2>
    <div class="all__filter">
      <adx-selectdropdown @selected="selectStatus" :label="`Status`" :options="statusList" />
      <div :class="['dropdown']" v-if="selectedStatus!='wnc'">
        <label class="small-font">Start Date</label>
        <v-date-picker
          v-model='startDate'
          :max-date='new Date()'
          :popoverVisibility="'focus'"
          :theme-styles='themeStyles'
          class='date-input'>
          <input
            class="calendar-start"
            placeholder= "DD/MM/YYYY"
            type='text'
            slot-scope='{ inputValue, updateValue }'
            :value='inputValue'
            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
        </v-date-picker>
      </div>
      <div :class="['dropdown']" v-if="selectedStatus!='wnc'">
        <label class="small-font">End Date</label>
        <v-date-picker
          v-model='endDate'
          :max-date='new Date()'
          :popoverVisibility="'focus'"
          :theme-styles='themeStyles'
          class='date-input'>
          <input
            class="calendar-start"
            placeholder= "DD/MM/YYYY"
            type='text'
            slot-scope='{ inputValue, updateValue }'
            :value='inputValue'
            @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
            @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
        </v-date-picker>
      </div>
      <!-- <button class="btn-large secondary" @click="download">Download</button> -->
    </div>
      <button class="btn-large secondary" @click="download">Download</button>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Secondary'
import calendar from 'v-calendar'
import moment from 'moment';
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-user_list',
  components: {
    'v-calendar': calendar,
    'adx-selectdropdown': SelectDropdown,
  },
  props: {

  },
  data() {
    return {
      startDate: null,
      endDate: null,
      selectedStatus: "",
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      statusList: [
        {
          "id": 1,
          "value": "",
          "label": "All New Users"
        },
        {
          "id": 2,
          "value": "wnc",
          "label": "With No Campaign"
        },
      ],
    }
  },
  computed: {
    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    let date = new Date()
    this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
    this.endDate = date
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    download() {
      let endDate = moment(this.endDate).format('YYYY-MM-DD')
      let startDate = this.startDate
      
      if (startDate) {
        startDate = moment(startDate).format('YYYY-MM-DD')
      } else {
        startDate = ''
      }
      
      if (this.selectedStatus == "wnc") {
        window.location = apiV2.userWithNoCampaignReport
      } else {
        window.location = apiV2.userReport(startDate,endDate)
      }
    },
    selectStatus(item) {
      this.selectedStatus = item.item.value
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>